<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M32 26.18V24h4a2 2 0 001.93-2.53l-4.36-16A2 2 0 0031.6 4h-15a2 2 0 00-1.93 1.47l-4.36 16A2 2 0 0012.19 24H22.5v12.5h-3A3.5 3.5 0 0016 40v2a2 2 0 002 2h12a2 2 0 002-2v-2a3.5 3.5 0 00-3.5-3.5h-3V24H30v2.18a3 3 0 102 0zM29 40v1H19v-1a.5.5 0 01.5-.5h9a.5.5 0 01.5.5zM17.32 7h13.52l3.81 14H13.5zM31 30a1 1 0 111-1 1 1 0 01-1 1z"/></svg>